// storybook-check-ignore
import React from 'react';

import { Box } from '@opendoor/bricks-next';

import { EiChevronDownIcon } from '../../../../shared/EiChevronDownIcon';

interface MobileSubMenuBackButtonProps {
  onClick: () => void;
}

export const MobileSubMenuBackButton: React.FC<MobileSubMenuBackButtonProps> = ({ onClick }) => {
  const buttonProps = { onPress: onClick } as any;

  return (
    <Box
      {...buttonProps}
      tag="button"
      alignItems="left"
      cursor="pointer"
      style={{ transform: 'rotate(90deg)' }}
      marginBottom="$16x"
      padding={0}
      width={16}
      height={16}
    >
      <EiChevronDownIcon />
    </Box>
  );
};
